(function () {
  if (window.customElements.get('rb-dropdown-section')) return;

  class RbDropdownSection extends HTMLElement {
    connectedCallback() {
      this._onClick = this._onClick.bind(this);
      this.addEventListener('click', this._onClick);
    }

    disconnectedCallback() {
      this.removeEventListener('click', this._onClick);
    }

    _onClick(event) {
      var trigger = event.target.closest('[data-rb-trigger]');
      if (!trigger || !this.contains(trigger)) return;

      event.preventDefault();
      var id = trigger.getAttribute('data-rb-trigger');
      var panel = this.querySelector('[data-rb-panel="' + id + '"]');
      var isOpen = trigger.classList.contains('is-active');

      this.querySelectorAll('[data-rb-trigger]').forEach(function (el) {
        el.classList.remove('is-active');
        el.setAttribute('aria-expanded', 'false');
      });
      this.querySelectorAll('[data-rb-panel]').forEach(function (el) {
        el.setAttribute('hidden', '');
      });

      if (isOpen || !panel) return;

      trigger.classList.add('is-active');
      trigger.setAttribute('aria-expanded', 'true');
      panel.removeAttribute('hidden');
      panel.scrollIntoView({ behavior: 'smooth', block: 'nearest' });
    }
  }

  class RbLazyVideo extends HTMLElement {
    connectedCallback() {
      var video = this.querySelector('video');
      if (!video) return;
      this.video = video;

      var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      var connection = navigator.connection || navigator.mozConnection || navigator.webkitConnection;
      var slow = connection && (connection.saveData || /2g/.test(connection.effectiveType || ''));

      if (reduceMotion || slow) {
        video.pause();
        video.removeAttribute('autoplay');
        video.setAttribute('hidden', '');
        return;
      }

      this.observer = new IntersectionObserver(
        function (entries) {
          entries.forEach(function (entry) {
            if (entry.isIntersecting) {
              video.play().catch(function () {});
            } else {
              video.pause();
            }
          });
        },
        { threshold: 0.25 }
      );
      this.observer.observe(video);
    }

    disconnectedCallback() {
      if (this.observer) this.observer.disconnect();
    }
  }

  customElements.define('rb-dropdown-section', RbDropdownSection);
  customElements.define('rb-lazy-video', RbLazyVideo);
})();
